import ProgramDashboard from '../../components/programs/Dashboard'
import { createApp } from 'vue';
import { createPinia } from 'pinia'
import VideoModal from '../../components/materials/VideoModal.vue'

const pinia = createPinia();

if (document.getElementById('program-dashboard')) {
    const app = createApp({
        components: {
            ProgramDashboard
        }
    });
    
    app.use(pinia)
    app.config.globalProperties.$basePath = process.env.MIX_APP_URL;
    app.mount('#program-dashboard');
}

if(document.getElementById('video-modal-container')) {
    const app2 = createApp({
        components: {
            VideoModal
        }
    });

    app2.use(pinia)
    app2.config.globalProperties.$basePath = process.env.MIX_APP_URL;
    app2.mount('#video-modal-container');
}
